
  import PTitle from '@/components/config/PTitle.vue'
  import { GForm } from '@/components/forms/GForm'
  import { Component } from 'vue-property-decorator'
  import axios from 'axios'
  import StockData from '@/components/config/StockData.vue'
  import { ComponentValue, Year } from '@/entities/vehicle'
  import { parseToNumber, removeAccents } from '@/utils/general'
  import { PersonType } from '@/entities/persons'
  import { AcquisitionType } from '@/entities/settings'
  import GDatePicker from '@/components/core/input/GDatePicker.vue'
  import GCostField from '@/components/core/input/GCostField.vue'
  import GRut from '@/components/core/input/GRut.vue'
  import dayjs from 'dayjs'
  import ImportAttribute from '@/components/config/importStock/ImportAttribute.vue'
  import _ from 'lodash'

  const { VUE_APP_BASE_URL } = process.env

@Component({
  components: { PTitle, StockData, GDatePicker, GCostField, GRut, ImportAttribute },
})
  export default class SystemImportStock extends GForm {
  dialog: boolean = true;
  file: File | null = null;
  stocks = []
  total = 0
  totalAnalyzed = 0
  displayError = false
  errorReadingFile= 'Error al leer el archivo, comprueba que sea la plantilla que descargaste'
  maxVehicleAgeAllowed = null
  years: Year[] = []
  personTypes: PersonType[] = []
  acquisitionType: AcquisitionType[] = []
  fuels: ComponentValue[] = []
  transmissions: ComponentValue[] = []
  dataTableData = []
  traction: ComponentValue[] = []
  headers: Array<{ text: string; value: string; align?: string; width?: string }> = [
    { text: 'Acción', value: '', align: 'center', width: '60px' },
    { text: 'Patente', value: 'ppu', align: 'center', width: '200px' },
    { text: 'Año', value: 'year', align: 'center', width: '200px' },
    { text: 'Marca', value: 'brand', align: 'center', width: '250px' },
    { text: 'Modelo', value: 'model', align: 'center', width: '250px' },
    { text: 'Versión', value: 'version', align: 'center', width: '350px' },
    { text: 'Atributos', value: '', align: 'center', width: '200px' },
    { text: 'Tracción', value: 'traction', align: 'center', width: '150px' },
    { text: 'Transmisión', value: 'transmission', align: 'center', width: '150px' },
    { text: 'Combustible', value: 'fuel', align: 'center', width: '150px' },
    { text: 'Propietario', value: 'owner', align: 'center', width: '300px' },
    { text: 'Tipo de persona', value: 'personType', align: 'center', width: '300px' },
    { text: 'RUT', value: 'uid', align: 'center', width: '400px' },
    { text: 'Tipo de adquisición', value: 'acquisitionType', align: 'center', width: '250px' },
    { text: 'Fecha de compra', value: 'date', align: 'center', width: '200px' },
    { text: '# LLave', value: 'key', align: 'center', width: '200px' },
    { text: 'Kilometraje', value: 'mileage', align: 'center', width: '200px' },
    { text: 'N Propietarios', value: 'owners', align: 'center', width: '200px' },
    { text: 'Precio de compra', value: 'purchasePrice', align: 'center', width: '200px' },
    { text: 'Precio de lista', value: 'priceList', align: 'center', width: '200px' },
    { text: 'Descuento', value: 'discount', align: 'center', width: '200px' },
    { text: 'Bono de renovación', value: 'renewalBonus', align: 'center', width: '250px' },
  ]

  async mounted () {
    const process = await this.fetchData({
      query: { name: 'find', model: 'Process' },
      filter: { table_name: { _eq: 'auto' } },
    })

    this.maxVehicleAgeAllowed = process?.[0]?.config?.maxVehicleAgeAllowed

    this.years = await this.fetchData({
      query: { name: 'find', model: 'Year' },
    })

    this.personTypes = await this.fetchData({
      query: { name: 'find', model: 'PersonType' },
    })

    this.acquisitionType = await this.fetchData({
      query: { name: 'find', model: 'AcquisitionType' },
      filter: { active: { _eq: true } },
    })

    this.fuels = await this.fetchData({
      query: { name: 'find', model: 'ComponentValue' },
      filter: {
        component: {
          name: { _eq: 'Combustible' },
        },
      },
    })

    this.traction = await this.fetchData({
      query: { name: 'find', model: 'ComponentValue' },
      filter: {
        _and: [
          { component: { name: { _eq: 'Tracción' } } },
          { value: { _neq: '4x2 y 4x4' } },
        ],
      },
    })

    this.transmissions = await this.fetchData({
      query: { name: 'find', model: 'ComponentValue' },
      filter: {
        component: {
          name: { _eq: 'Transmisión' },
        },
      },
    })
  }

  closeDialog () {
    this.dialog = false
  }

  handleFileChange (file: File) {
    this.file = file
    this.displayError = false
  }

  async uploadFile () {
    if (!this.file) return
    this.loadingForm = true
    const formData = new FormData()
    formData.append('file', this.file)
    try {
      const { data: response } = await axios.post(`${VUE_APP_BASE_URL}/convert-pdf-to-image/upload-stock`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      await this.handleData(response.data)
      // this.dialog = false
    } catch (error) {
      this.displayError = true
      this.loadingForm = false
      console.error(error)
    }
  }

  async handleData (data) {
    this.total = data.length
    this.stocks = []
    for (const item of data) {
      await new Promise(resolve => setTimeout(resolve, 100))

      const brand = await this.findBrand(item.year, item.brand)

      const model = await this.findModel(item.year, item.model, brand?.match)

      const version = await this.findVersion(item.year, item.version, model?.match, brand?.match)

      const acquisitionType = this.acquisitionType.find(type => {
        if (item.acquisitionType?.toLowerCase() === 'consigna') {
          return type.description.toLowerCase() === 'consignación'
        }

        return type.description.toLowerCase() === item.acquisitionType?.toLowerCase()
      })

      const personType = this.personTypes.find(type => type.description.toLowerCase() === item.personType?.toLowerCase())
      const fuel = this.fuels.find(fuel => removeAccents(fuel.value.toLowerCase()) === removeAccents(item.fuel?.toLowerCase())) || { value: '' }
      const traction = this.traction.find(traction => removeAccents(traction.value.toLowerCase()) === removeAccents(item.traction?.toLowerCase())) || { value: '' }
      const transmission = this.transmissions.find(transmission => removeAccents(transmission.value.toLowerCase()) === removeAccents(item.transmission?.toLowerCase())) || { value: '' }

      const data = {
        year: item.year,
        brand,
        model,
        version,
        traction,
        transmission,
        fuel,
        owner: item.owner,
        acquisitionType,
        date: dayjs(item.date, 'DD/MM/YYYY', true).isValid() ? item.date : null,
        discount: item.discount,
        key: item.key,
        mileage: item.mileage,
        owners: item.owners,
        ppu: item.ppu,
        uid: item.uid,
        personType,
        priceList: item.priceList,
        purchasePrice: item.purchasePrice,
        renewalBonus: item.renewalBonus,
        loading: false,
        generation: null,
        id: this.getGenerateRandomKey(),
        checkAttributes: true,
        errorMessage: '',
      }
      this.stocks.push(data)
      this.totalAnalyzed += 1
      this.dataTableData = {
        ...this.dataTableData,
        [data.id]: _.cloneDeep(data),
      }
    }

    this.dialog = false
    this.loadingForm = false
  }

  getGenerateRandomKey () {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    let result = ''
    for (let i = 0; i < 4; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length))
    }
    return result
  }

  async findBrand (year, name) {
    const brands = await this.fetchData({
      query: { name: 'findLite', model: 'Brand', order: { name: 'asc' } },
      filter: {
        models: {
          versions: {
            years: {
              id_year: {
                _gte: parseToNumber(year) - parseToNumber(this.maxVehicleAgeAllowed),
                _lte: parseToNumber(year) + parseToNumber(this.maxVehicleAgeAllowed),
              },
            },
          },
        },
      },
      force: true,
    })

    const payload = {
      name,
      data: brands,
      exact_match: true,
    }

    try {
      const { data: { match = '' } } = await axios.post(`${VUE_APP_BASE_URL}/convert-pdf-to-image/find-match`, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      })

      return { match: match ?? '', data: brands, firstLoad: true }
    } catch (error) {
      console.error(error)
    }
  }

  async fetchModels (item) {
    if (item?.model?.firstLoad) {
      item.model.firstLoad = false
      return
    }

    this.dataTableData[item.id].model.data = await this.fetchData({
      query: {
        name: 'findLite',
        model: 'Model',
        order: {
          name: 'asc',
        },
      },
      filter: {
        _and: [
          { id_brand: { _eq: item.brand.id } },
          {
            versions: {
              years: {
                id_year: {
                  _gte: parseToNumber(item.year),
                  _lte: parseToNumber(item.year),
                },
              },
            },
          },
        ],
      },
      force: true,
    })
  }

  async fetchVersions (item) {
    if (item?.version?.firstLoad) {
      item.version.firstLoad = false
      return
    }

    this.dataTableData[item.id].version.data = await this.fetchData({
      query: {
        name: 'findLite',
        model: 'VersionYear',
        order: {
          id_year: 'desc',
        },
      },
      filter: {
        _and: [
          {
            version: {
              _and: [
                {
                  model: { _and: [{ id_brand: { _eq: item.brand.id } }, { id: { _eq: item.model.id } }] },
                },
              ],
            },
          },
          {
            id_year: {
              _gte: parseToNumber(item.year),
              _lte: parseToNumber(item.year),
            },
          },
        ],
      },
      force: true,
    })
  }

  async findModel (year, name, brand) {
    if (!brand?.id) {
      return {
        match: '',
        data: [],
      }
    }
    const models = await this.fetchData({
      query: {
        name: 'findLite',
        model: 'Model',
        order: {
          name: 'asc',
        },
      },
      filter: {
        _and: [
          { id_brand: { _eq: brand.id } },
          {
            versions: {
              years: {
                id_year: {
                  _gte: parseToNumber(year) - parseToNumber(this.maxVehicleAgeAllowed),
                  _lte: parseToNumber(year) + parseToNumber(this.maxVehicleAgeAllowed),
                },
              },
            },
          },
        ],
      },
      force: true,
    })

    const payload = {
      name,
      data: models,
    }

    try {
      const { data: { match = '' } } = await axios.post(`${VUE_APP_BASE_URL}/convert-pdf-to-image/find-match`, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      })

      return { match: match ?? '', data: models, firstLoad: true }
    } catch (error) {
      console.error(error)
    }
  }

  async findVersion (year, name, model, brand) {
    if (!model?.id || !brand?.id) {
      return {
        match: '',
        data: [],
      }
    }
    const versions = await this.fetchData({
      query: {
        name: 'findLite',
        model: 'VersionYear',
        order: {
          id_year: 'desc',
        },
      },
      filter: {
        _and: [
          {
            version: {
              _and: [
                {
                  model: { _and: [{ id_brand: { _eq: brand.id } }, { id: { _eq: model?.id } }] },
                },
              ],
            },
          },
          {
            id_year: {
              _gte: parseToNumber(year) - parseToNumber(this.maxVehicleAgeAllowed),
              _lte: parseToNumber(year) + parseToNumber(this.maxVehicleAgeAllowed),
            },
          },
        ],
      },
      force: true,
    })

    const payload = {
      name,
      data: versions.map(v => {
        return {
          name: v.version.name,
          id: v.id,
        }
      }),
    }

    try {
      const { data: { match = '' } } = await axios.post(`${VUE_APP_BASE_URL}/convert-pdf-to-image/find-match`, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      })

      return { match, data: versions, firstLoad: true }
    } catch (error) {
      console.error(error)
    }
  }

  submitChanges (item) {
    item.loading = true

    console.log('Sending updated item:', item)

    // Remove the item from this.stocks after submission
    const index = this.stocks.findIndex(stock => stock === item)
    if (index !== -1) {
      this.stocks.splice(index, 1)
    }
  }

  validateFields (item) {
  item.errorMessages = ''
  const fields = [
    { key: 'ppu', label: 'Patente' },
    { key: 'year', label: 'Año' },
    { key: 'owner', label: 'Propietario' },
    { key: 'date', label: 'Fecha de compra' },
    { key: 'purchasePrice', label: 'Precio de compra' },
    { key: 'priceList', label: 'Precio de lista' },
    { key: 'generation', label: 'Atributos' },
    { key: 'key', label: '# Llave' },
    { key: 'mileage', label: 'Kilometraje' },
    { key: 'owners', label: 'Propietarios' },
    { key: 'personType', label: 'Tipo de persona' },
    { key: 'uid', label: 'RUT' },
    { key: 'acquisitionType', label: 'Tipo de adquisición' },
  ]
  fields.forEach((f, index) => {
    if (!item[f.key]) {
      item.errorMessages += `${!item?.errorMessages?.length ? '' : ', '} ${f.label}`
    }
  })
  const nested = [
    { path: ['brand', 'match', 'id'], label: 'Marca' },
    { path: ['model', 'match', 'id'], label: 'Modelo' },
    { path: ['version', 'match', 'id'], label: 'Versión' },
  ]
  nested.forEach(n => {
    let value = item
    n.path.forEach(p => { value = value ? value[p] : undefined })
    if (!value) item.errorMessages += ` ${n.label}. `
  })
  return !!item.errorMessages
  }
  }
